import React from 'react';
import { PartnerLedgerTransactions } from '../components/integration/PartnerLedgerPages';

interface UserInfo {
  username: string;
  displayName: string;
  role: string;
  orgName: string;
  orgIcon: string;
  loginTime: string;
}

function KAISTTransactions({ user }: { user: UserInfo }) {
  return <PartnerLedgerTransactions partner="KAIST" user={user} />;
}

export default React.memo(KAISTTransactions);
